import { useRequest } from 'ahooks';
import { useState } from 'react';
import {
  addBalShareMemberService,
  deleteBalShareMemberService,
  modBalShareMemberService,
  queryBsTemplateService,
  queryAccountResourceService,
  queryAllUnitTypeService
} from './services';

export default function StaticPoolMgrModel() {
  const [selectedAccount, setSelectedAccount] = useState<any>(null); // 左侧选中账户
  const [selectedRows, setSelectedRows] = useState<any[]>([]); // 选择成员列表

  const { data: bsTemplateList, run: queryBsTemplateList } = useRequest(
    queryBsTemplateService,
    {
      manual: true,
    },
  );

  const { loading: addBalShareMemberLoading, runAsync: addBalShareMember } =
    useRequest(addBalShareMemberService, {
      manual: true,
    });

  const { loading: modBalShareMemberLoading, runAsync: modBalShareMember } =
    useRequest(modBalShareMemberService, {
      manual: true,
    });

  const {
    loading: deleteBalShareMemberLoading,
    runAsync: deleteBalShareMember,
  } = useRequest(deleteBalShareMemberService, {
    manual: true,
  });

  const { data: accountResourceList, run: queryAccountResourceList } = useRequest(
    queryAccountResourceService,
    {
      manual: true,
    },
  );

  const { data: unitTypeList, run: queryUnitTypeList } = useRequest(
    queryAllUnitTypeService,
    {
      manual: true,
    },
  );

  return {
    selectedAccount,
    setSelectedAccount,
    selectedRows,
    setSelectedRows,
    bsTemplateList,
    queryBsTemplateList,
    addBalShareMember,
    addBalShareMemberLoading,
    modBalShareMember,
    modBalShareMemberLoading,
    deleteBalShareMember,
    deleteBalShareMemberLoading,
    accountResourceList,
    queryAccountResourceList,
    unitTypeList,
    queryUnitTypeList
  };
}
